import { getAccountMembershipState } from '../repositories/accountRepository'

export const MEMBERSHIP_STATES = {
  ACTIVE: 'active',
  ACTIVE_TRIAL: 'trialing',
  LAPSED: 'lapsed',
  SINGLE_CLASS: 'SINGLE_CLASS',
  INACTIVE: 'inactive',
  REFUNDED: 'refunded',
  NEVER_ENROLLED: 'NEVER_ENROLLED',
} as const

export default function getMembershipState() {
  return getAccountMembershipState()
}
